
import React from "react";
import TagBadge from "./TagBadge";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { ITournamentEditionMatch } from "../../../../../services";

export interface MatchCardProps {
    publicId: string;
    match: ITournamentEditionMatch;
}

export function matchParticipants(t: ITournamentEditionMatch) {
    return (t.tournament_edition_registered_participant_ids ?? []).map((external_id) => ({ ...t.extra_data?.participants_profiles?.[external_id], external_id }));
}

export function matchScores(t: ITournamentEditionMatch): number[] {
    return Object.values(Object.values(t.scores ?? {})?.[0] ?? {}).map((s) => Object.values(s)?.[0]);
}

function MatchCard({ publicId, match: t }: MatchCardProps) {

    const labels = i18nManager.Labels.schedule;
    const scores = matchScores(t);
    const participants = matchParticipants(t);
    const statusLabel = ({ UPCOMING: labels.upcoming, ONGOING: labels.live, ENDED: labels.past } as Record<string, string>)[t.status] ?? t.status;

    return (<a className={styles["news-card"]} target="_blank" rel="noreferrer" href={Utils.buildTournamentMatchLink(publicId, t)}>
        {t.tournament_edition?.logo_url && (<img className={styles["news-card-bg"]} src={t.tournament_edition.logo_url} alt="" aria-hidden />)}
        <div className={styles["news-card-shade"]} />
        <div className={styles["news-card-body"]}>
            <TagBadge>{statusLabel}</TagBadge>
            <div className={styles["news-card-date"]}>{Utils.fineDate(new Date(t.start_date))}</div>
            <div className={styles["news-card-title"]}>{t.tournament_edition?.name}</div>
            <div className={styles["news-card-sides"]}>
                {participants.map((p: any, i: number) => (<React.Fragment key={p.external_id}>
                    {i > 0 && (<span className={styles["match-vs"]}>vs</span>)}
                    <img alt={p.external_id} src={p.profile_picture_url ?? p.logo_url} />
                    <span>{p.name ?? p.username}</span>
                </React.Fragment>))}
            </div>
            {scores.length > 0 && (<div className={styles["news-card-score"]}>{scores.join(" - ")}</div>)}
        </div>
    </a>);
}

export default MatchCard;
